var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPublishing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.85L5.125 9.725C4.925 9.925 4.68767 10.021 4.413 10.013C4.13833 10.005 3.90067 9.90067 3.7 9.7C3.51667 9.5 3.42067 9.26667 3.412 9C3.40333 8.73333 3.49933 8.5 3.7 8.3L7.3 4.7C7.4 4.6 7.50833 4.52933 7.625 4.488C7.74167 4.44667 7.86667 4.42567 8 4.425C8.13333 4.42433 8.25833 4.44533 8.375 4.488C8.49167 4.53067 8.6 4.60133 8.7 4.7L12.3 8.3C12.5 8.5 12.596 8.73333 12.588 9C12.58 9.26667 12.484 9.5 12.3 9.7C12.1 9.9 11.8627 10.0043 11.588 10.013C11.3133 10.0217 11.0757 9.92567 10.875 9.725L9 7.85V15C9 15.2833 8.904 15.521 8.712 15.713C8.52 15.905 8.28267 16.0007 8 16C7.71733 15.9993 7.48 15.9033 7.288 15.712C7.096 15.5207 7 15.2833 7 15V7.85ZM0 4V2C0 1.45 0.196 0.979333 0.588 0.588C0.98 0.196666 1.45067 0.000666667 2 0H14C14.55 0 15.021 0.196 15.413 0.588C15.805 0.98 16.0007 1.45067 16 2V4C16 4.28333 15.904 4.521 15.712 4.713C15.52 4.905 15.2827 5.00067 15 5C14.7173 4.99933 14.48 4.90333 14.288 4.712C14.096 4.52067 14 4.28333 14 4V2H2V4C2 4.28333 1.904 4.521 1.712 4.713C1.52 4.905 1.28267 5.00067 1 5C0.717333 4.99933 0.48 4.90333 0.288 4.712C0.0960001 4.52067 0 4.28333 0 4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPublishing);
export default __webpack_public_path__ + "static/media/icon-publishing.f0c2797f66df0fd029c7e86358f0b0b9.svg";
export { ForwardRef as ReactComponent };